import { Settings, Shield, Bell, Key } from 'lucide-react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { useAuthStore } from '@/store/authStore'
import { Avatar, AvatarFallback, getInitials } from '@/components/ui/avatar'
import { Separator } from '@/components/ui/separator'

const SETTING_GROUPS = [
  {
    icon: <Shield className="h-4 w-4 text-blue-500" />,
    title: 'Security',
    items: ['Two-factor authentication', 'Active sessions', 'Login history'],
  },
  {
    icon: <Bell className="h-4 w-4 text-amber-500" />,
    title: 'Notifications',
    items: ['Email notifications', 'SMS alerts for high-value payments', 'Approval request alerts'],
  },
  {
    icon: <Key className="h-4 w-4 text-purple-500" />,
    title: 'Access & Permissions',
    items: ['Role management', 'Payment limits', 'Approval chain configuration'],
  },
]

export default function SettingsPage() {
  const user = useAuthStore((s) => s.user)

  return (
    <div className="max-w-2xl space-y-6">
      {/* Profile */}
      <Card>
        <CardHeader>
          <CardTitle className="text-base">Profile</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex items-center gap-4">
            <Avatar size="lg">
              <AvatarFallback className="text-base">
                {user ? getInitials(user.name) : 'U'}
              </AvatarFallback>
            </Avatar>
            <div>
              <p className="font-semibold">{user?.name}</p>
              <p className="text-sm text-muted-foreground">{user?.email}</p>
              <span className="mt-1 inline-block rounded-full bg-primary/10 px-2 py-0.5 text-xs font-medium text-primary">
                {user?.role}
              </span>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Setting groups */}
      {SETTING_GROUPS.map((group) => (
        <Card key={group.title}>
          <CardHeader className="pb-3">
            <CardTitle className="flex items-center gap-2 text-base">
              {group.icon}
              {group.title}
            </CardTitle>
          </CardHeader>
          <CardContent className="p-0">
            {group.items.map((item, idx) => (
              <div key={item}>
                <div className="flex items-center justify-between px-6 py-3">
                  <span className="text-sm">{item}</span>
                  <span className="rounded bg-muted px-1.5 py-0.5 text-[10px] text-muted-foreground">
                    Coming soon
                  </span>
                </div>
                {idx < group.items.length - 1 && <Separator />}
              </div>
            ))}
          </CardContent>
        </Card>
      ))}

      <p className="text-center text-xs text-muted-foreground">
        <Settings className="mr-1 inline h-3 w-3" />
        Portal v1.0 · ICICI CIB API Integration
      </p>
    </div>
  )
}
